export default __webpack_public_path__ + "8291be8.png";